import React from 'react';

const colors_polizas = {
	// ACCIDENTES PERSONALES
	63: '#009FE3',
	// ACCIDENTES PERSONALES GM
	55: '#009FE3',
	// ACCIDENTES PERSONALES VIDA
	18: '#009FE3',
	// CÁNCER
	32: '#EC008C',
	// CASH FLOW
	54: '#009FE3',
	// CHECK UP
	33: '#009FE3',
	// DENTAL
	11: '#009FE3',
	// DESEMPLEO
	30: '#009FE3',
	// EXCESOS DE SA GMM
	4: '#EC008C',
	// GASTOS MÉDICOS MENORES
	6: '#009FE3',
	// GIMNASIO
	73: '#009FE3',
	// GMM
	1: '#009FE3',
	// GMM
	60: '#009FE3',
	// GMM DEPENDIENTES
	14: '#009FE3',
	// GRAVES ENFERMEDADES
	35: '#EC008C',
	// HOSPITALIZACIÓN
	31: '#009FE3',
	// MASCOTAS
	74: '#009FE3',
	// MEMBRESÍA DE CONSULTAS
	59: '#0075C9',
	// PG
	15: '#009FE3',
	// PG
	62: '#009FE3',
	// VISIÓN
	5: '#009FE3',
	// DEUDORES
	16: '#8DC63F',
	// EDUCACIONAL
	34: '#8DC63F',
	// EXCESOS DE SA VIDA
	8: '#8DC63F',
	// FUNERARIOS
	9: '#8DC63F',
	// FUNERARIOS PADRES
	10: '#8DC63F',
	// MUERTE ACCIDENTAL
	64: '#8DC63F',
	// SERVICIOS FUNERARIOS
	58: '#8DC63F',
	// VIDA
	2: '#8DC63F',
	// VIDA
	61: '#8DC63F',
	// VIDA CÓNYUGE
	36: '#8DC63F',
	// FLOTILLA
	46: '#ffb700',
	// FLOTILLA ARRENDAMIENTOS
	25: '#ffb700',
	// FLOTILLA CARGO A TC
	22: '#ffb700',
	// FLOTILLA DXN
	23: '#ffb700',
	// FLOTILLA PORTAL
	37: '#ffb700',
	// FLOTILLA UTILITARIOS
	24: '#ffb700',
	// INDIVIDUALES
	21: '#ffb700',
	// INDIVIDUALES EXTERNOS
	26: '#ffb700',
	// ARRENDADORAS
	42: '#ffb700',
	// CONTENEDORES
	52: '#ffb700',
	// DAÑOS
	43: '#ffb700',
	// EMPRESARIAL
	44: '#ffb700',
	// INDIVIDUALES
	53: '#ffb700',
	// SEGURO EXTERNO
	51: '#ffb700',
	// Tradicional
	57: '#ffb700',
	// TRANSPORTES
	45: '#ffb700',
	// FIANZAS ADMINISTRATIVAS
	68: '#009FE3',
	// FIANZAS DE CRÉDITO
	69: '#009FE3',
	// FIANZAS DE FIDELIDAD
	66: '#009FE3',
	// FIANZAS JUDICIALES
	67: '#009FE3',
	// ADMINISTRACIÓN DE CAJA DE AHORRO
	71: '#FFB700',
	// ADMINISTRACIÓN DE FONDO DE AHORRO
	70: '#FFB700',
	// ADMINISTRACIÓN DE PLAN DE PENSIONES
	72: '#FFB700',
	// ADMINISTRACIÓN DE DÍAS DE AGUINALDO
	108: '#FFB700',
	// ADMINISTRACIÓN DE VALES DE GASOLINA
	109: '#FFB700',
	// COLORES CLIENTE DIDI
	2001: '#fd9153',
};

const colors_aseguradoras = {
	// AXA
	3: '#3b40d8',
  	// QUALITAS
	22: '#F1F1F1',
	// ABA
	23: '#F1F1F1',
	// ATLAS
	1: '#d91b22',
	// HDI
	34: '#468540',
	// MAPFRE
	29: '#af002b',
	// ANA SEGUROS
	81: '#F1F1F1',
	// PRIMERO_SEGUROS
	65: '#F1F1F1',
	// ZURICH
	103: '#f8f9fa',
	// GNP
	4: '#F5F5F5',
};

const colors_tipos_autos = {
	// Autos y Motocicletas
	1: '#ffb700',
  	// Autos
	2: '#fd9153',
	// Motocicletas
	3: '#fd9153',
};

const displays = {
	'casa-cotizacion': 'd-none',
	'auto-cotiza': 'd-none',
	'beneficios-flexibles': 'd-none',
};

function Backgroud(props) {
	let color = null;
    //console.log(props);
	if (props.id_tipo_poliza != null) {
		color = colors_polizas[props.id_tipo_poliza];
	}
	if (props.id_aseguradora != null) {
		color = colors_aseguradoras[props.id_aseguradora];
	}
	if (props.id_tipo_auto != null) {
		color = colors_tipos_autos[props.id_tipo_auto];
	}
	if (props.is_mazda !=null && props.is_mazda) {
		//color='#9AAAA9'; 
		color='#910A2D';
	}
	if (color == undefined) {
		color = '#009FE3';
	}

	let display = displays[props.id_tipo_poliza];
	if (display == undefined) {
		display = 'd-block';
	}
	if (props.only_icon == null) {
		return (
			<path className={display} fill={color} d="M66,78.08H12c-6.6,0-12-5.41-12-12.03V12.03C0,5.41,5.4,0,12,0h54c6.6,0,12,5.41,12,12.03v54.02C78,75.34,72.6,78.08,66,78.08z"/>
		);
	} else {
		return null;
	}
};

export default Backgroud;
